import { CharacterCountPipe } from 'src/app/_helpers/pipes/character-count.pipe';
import { CommonModule } from '@angular/common';
import { ConfigurableMatTableComponent } from '../../_components/shared/configurable-mat-table/configurable-mat-table.component';
import { ConfirmTabChangeDirective } from 'src/app/_directives/confirm-tab-change.directive';
import { CurrencyFormatDirective } from 'src/app/_directives/currency-format.directive';
import { DClickStopPropagation } from 'src/app/_directives/DStopPropegation';
import { DeactivationAwareDirective } from 'src/app/_directives/deactivation-aware.directive';
import { DisplayMomentDatePipe} from '../../_helpers/pipes/display-moment-date.pipe'
import { ExportButtonComponent } from 'src/app/_components/shared/export-button/export-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelpDirective } from 'src/app/_helpers/madcap-web-help/directive/help.directive';
import { HighchartsChartModule } from 'highcharts-angular';
import { InputAutoFocusDirective } from 'src/app/_directives/input-auto-focus.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { PropertyAccessorPipe } from '../../_helpers/pipes/property-accessor-pipe';
import { RemoveSpaceOnlyDirective } from 'src/app/_directives/remove-space-only.directive';
import { ResourcesComponent } from '../../_components/resources/resources.component';
import { ResourcesPanelComponent } from '../../_components/shared/resources-panel/resources-panel.component';
import { UnixToCentralTimePipe } from 'src/app/_helpers/pipes/unix-to-central-date.pipe';
import { UnixToMomentDatePipe } from 'src/app/_helpers/pipes/unix-to-moment-date.pipe';
import { UnsavedChangesComponent } from '../../_helpers/unsaved-changes/unsaved-changes.component';
import { UserHasRolePipe } from 'src/app/_helpers/pipes/user-has-role.pipe';
import { UserNamePipe } from '../../_helpers/pipes/user-name.pipe';
@NgModule({
  declarations: [
    CharacterCountPipe,
    ConfigurableMatTableComponent,
    ConfirmTabChangeDirective,
    CurrencyFormatDirective,
    DClickStopPropagation,
    DeactivationAwareDirective,
    DisplayMomentDatePipe,
    ExportButtonComponent,
    HelpDirective,
    InputAutoFocusDirective,
    PropertyAccessorPipe,
    RemoveSpaceOnlyDirective,
    ResourcesComponent,
    ResourcesPanelComponent,
    UnixToCentralTimePipe,
    UnixToMomentDatePipe,
    UnsavedChangesComponent,
    UserHasRolePipe,
    UserNamePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HighchartsChartModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
  exports: [
    CharacterCountPipe,
    ConfigurableMatTableComponent,
    ConfirmTabChangeDirective,
    CurrencyFormatDirective,
    DClickStopPropagation,
    DeactivationAwareDirective,
    DisplayMomentDatePipe,
    ExportButtonComponent,
    FormsModule,
    HelpDirective,
    HighchartsChartModule,
    InputAutoFocusDirective,
    MatButtonModule,
    MatCheckboxModule, 
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
    PropertyAccessorPipe,
    ReactiveFormsModule,
    RemoveSpaceOnlyDirective,
    ResourcesPanelComponent,
    ResourcesPanelComponent,
    UnixToCentralTimePipe,
    UnixToMomentDatePipe,
    UnsavedChangesComponent,
    UserHasRolePipe,
    UserNamePipe,
  ] // export it so it's useable in modules that import sharedModule
})
export class SharedModule { }
